import { jsx } from "react/jsx-runtime";
import { cva } from "../../../node_modules/class-variance-authority/dist/index.js";
import { forwardRef } from "react";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
import BaseButton from "../BaseButton/BaseButton.js";
const iconButtonVariants = cva([], {
  variants: {
    size: {
      xs: ["text-xs w-8 h-8 rounded-lg"],
      sm: ["text-sm w-9 h-9 rounded-[10px]"],
      normal: ["text-base w-10 h-10 rounded-[10px]"],
      lg: ["text-lg w-11 h-11 rounded-xl"],
      xl: ["text-xl w-12 h-12 rounded-xl"]
    }
  },
  defaultVariants: {
    size: "normal"
  }
});
const IconButton = forwardRef((props, ref) => {
  const { children, size, className, ...rest } = props;
  return /* @__PURE__ */ jsx(BaseButton, { ref, ...rest, className: twMerge(iconButtonVariants({ size, className })), children });
});
export {
  IconButton as default
};
//# sourceMappingURL=IconButton.js.map
